import { Modal, Button } from "@hiya/ui";
import type { User } from "../../types/user";

interface DisableUserModalProps {
  user: User | null;
  onClose: () => void;
  onConfirm: () => void;
}

export function DisableUserModal({ user, onClose, onConfirm }: Readonly<DisableUserModalProps>) {
  return (
    <Modal open={user !== null} title="Disable User" onClose={onClose}>
      <p className="text-sm text-text-primary leading-[1.5]">
        Are you sure you want to disable{" "}
        <span className="font-semibold">
          {user?.name} {user?.surname}
        </span>{" "}
        user? This user will lose access immediately, and will no longer be able
        to log in.
      </p>
      <div className="flex gap-2">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Disable user
        </Button>
      </div>
    </Modal>
  );
}
